import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import './style.scss'

const Loading = ({ loading, message }) => {
    const [ node ] = useState(document.createElement('div'))

    useEffect(() => {
        loading && document.body.appendChild(node)

        return () => loading && document.body.removeChild(node)
    }, [ loading ])

    return ReactDOM.createPortal((
        <div className="loading">
            <i className="fas fa-spinner rotating" />
            <div className="loading--message">{message}</div>
        </div>
    ), node)
}

export default Loading
